// The phase · states pill (prototype only). Switches phase, resets to signed
// out, expires the session, opens admin, and lists the demo credentials. Shown
// only with the local backend and unless VITE_SHOW_DEV_PANEL=false.
import type { Phase } from '../types';
import { MONO } from './primitives';

const PHASES: Phase[] = ['gathering', 'planning', 'final'];

const stateBtn: React.CSSProperties = {
  textAlign: 'left',
  minHeight: 44,
  padding: '0 12px',
  borderRadius: 9,
  border: '1px solid rgba(234,247,248,0.2)',
  background: 'none',
  color: 'var(--body-2)',
  fontFamily: MONO,
  fontSize: 13,
  cursor: 'pointer',
  outline: 'none',
};

export function DevPill({
  open,
  onToggle,
  currentPhase,
  onPickPhase,
  onReset,
  onExpire,
  onAdmin,
  demoCode,
}: {
  open: boolean;
  onToggle: () => void;
  currentPhase: Phase;
  onPickPhase: (p: Phase) => void;
  onReset: () => void;
  onExpire: () => void;
  onAdmin: () => void;
  demoCode: string;
}) {
  const heading: React.CSSProperties = {
    fontFamily: MONO,
    fontSize: 11,
    letterSpacing: '0.14em',
    textTransform: 'uppercase',
    color: 'var(--cyan)',
  };
  return (
    <div
      style={{
        position: 'fixed',
        right: 14,
        bottom: 14,
        zIndex: 80,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        gap: 8,
      }}
    >
      {open && (
        <div
          style={{
            background: 'rgba(4,38,46,0.96)',
            border: '1px solid rgba(127,227,232,0.4)',
            borderRadius: 14,
            padding: 14,
            width: 236,
            boxShadow: '0 18px 40px rgba(0,0,0,0.4)',
            backdropFilter: 'blur(10px)',
          }}
        >
          <div style={heading}>phase</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}>
            {PHASES.map((p) => {
              const active = p === currentPhase;
              return (
                <button
                  key={p}
                  type="button"
                  onClick={() => onPickPhase(p)}
                  style={{
                    textAlign: 'left',
                    minHeight: 44,
                    padding: '0 12px',
                    borderRadius: 9,
                    border: '1px solid rgba(234,247,248,0.2)',
                    background: active ? 'var(--cyan)' : 'transparent',
                    color: active ? 'var(--deep)' : 'var(--body-2)',
                    fontFamily: MONO,
                    fontSize: 13,
                    cursor: 'pointer',
                    outline: 'none',
                  }}
                >
                  {p}
                </button>
              );
            })}
          </div>

          <div style={{ ...heading, marginTop: 14 }}>states</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6, marginTop: 8 }}>
            <button type="button" style={stateBtn} onClick={onReset}>
              reset to signed out
            </button>
            <button type="button" style={stateBtn} onClick={onExpire}>
              expire the session
            </button>
            <button type="button" style={stateBtn} onClick={onAdmin}>
              open my admin
            </button>
          </div>

          <div
            style={{
              fontFamily: MONO,
              fontSize: 11,
              lineHeight: 1.6,
              color: 'var(--muted)',
              marginTop: 14,
              borderTop: '1px solid rgba(234,247,248,0.16)',
              paddingTop: 10,
            }}
          >
            try joe@example.com or nan@example.com · code {demoCode} · anything else is "not on the
            list"
          </div>
        </div>
      )}
      <button
        type="button"
        onClick={onToggle}
        style={{
          minHeight: 44,
          padding: '0 14px',
          borderRadius: 22,
          border: '1px solid rgba(127,227,232,0.4)',
          background: 'rgba(4,38,46,0.92)',
          color: 'var(--cyan)',
          fontFamily: MONO,
          fontSize: 12,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          cursor: 'pointer',
          backdropFilter: 'blur(10px)',
          outline: 'none',
        }}
      >
        {open ? 'close' : 'phase · states'}
      </button>
    </div>
  );
}
